<template>
  <b-navbar toggleable="lg md sm" class="homepage-navbar" fixed="top">
    <a
      href="https://public.carriercommunity.com/"
      target="_self"
      class="p-0 logo"
    >
      <img class="img-logo" src="@/assets/logo/CC-Logo.png" alt="" />
    </a>
    <b-navbar-toggle target="nav-left" >
      <template #default="{ expanded }">
        <i v-if="expanded"  class="fa fa-times"></i>
        <i v-else  class="fa fa-bars"></i>
      </template>
    </b-navbar-toggle>

    <b-collapse id="nav-left" is-nav>
      <b-navbar-nav class="navbar_links">
        <template v-for="(item, index) in menus">
          <a v-if="item.subMenus.length === 0" :href="item.url" class="main-link"
          >{{item.display_name}}</a
        >
        <li v-else class="nav-item dropdown" style="display: inline-block">
          <a
            :href="item.url"
            target="_self"
            class="main-link"
            dropright
            data-toggle="dropdown"
          >
           {{item.display_name}}<i v-if="item.subMenus.length" class="fas fa-chevron-down menu-arrows" />
          </a>
          <ul class="dropdown-menu">
            <li v-for="(subItem, index) in item.subMenus" class="nav-item dropdown sub-nav-item">
              <a
                :href="subItem.url"
                dropright
                data-toggle="dropdown"
                target="_self"
                class="dropdown-item"
              >
                {{subItem.display_name}} <i v-if="subItem.subMenus.length"  class="fas fa-chevron-right menu-arrows" />
              </a>
              <ul class="sub-dropdown-menu dropdown-in-small-screen">
                <li v-for="(subSubMenu, index) in subItem.subMenus">
                  <a
                    :href="subSubMenu.url"
                    target="_self"
                    class="dropdown-item"
                    >{{subSubMenu.display_name}}</a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>
        </template>
      </b-navbar-nav>
      <div class="right-navbar">
      <b-navbar-nav class="pt-2">
        <router-link
          v-if="!isLoggedIn"
          :to="{ name: 'auth/SignUp' }"
          :style="$route.path.includes('sign-up') && 'color:#efefef'"
          class="main-link"
        >
          REGISTER
        </router-link>
        <router-link
          v-if="!isLoggedIn"
          :to="{ name: 'signIn' }"
          :style="$route.path.includes('sign-in') && 'color:#efefef'"
          class="main-link"
        >
          LOGIN
        </router-link>
      </b-navbar-nav>
      <b-navbar-nav
        v-if="$route.path.includes('homepage') && !isLoggedIn"
        class="login-inputs"
      >
        <b-nav-form>
          <b-input
            v-validate="'required|email'"
            name="email"
            v-model="email"
            autocorrect="off"
            autocapitalize="off"
            autocomplete="off"
            id="email"
            class="singnin-input"
            placeholder="corporate email"
            :class="{ 'is-danger': errors.has('email') }"
          >
          </b-input>
          <b-input
            v-validate="'required'"
            v-model="password"
            id="password"
            class="singnin-input"
            placeholder="password"
            name="password"
            type="password"
            :class="{ 'is-danger': errors.has('password') }"
          >
          </b-input>
          <b-button
            size="sm"
            class="login-button my-2 my-sm-0"
            variant="outline-info"
            @click.prevent="logIn"
          >
            LOGIN
          </b-button>
        </b-nav-form>
        <div class="nav-links">
          <router-link :to="{ name: 'ForgotPassword' }">
            Forgot password?
          </router-link>
          <br />
          <p v-if="error.length" class="warning-text">{{ error }}</p>
          <small v-if="errors.has('email')" class="warning-text is-danger">
            {{ errors.first("email") }}
          </small>
          <small v-if="errors.has('password')" class="warning-text is-danger">
            {{ errors.first("password") }}
          </small>
        </div>
      </b-navbar-nav>

    </div></b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Navbar',
  data() {
    return {
      email: '',
      password: '',
      error: '',
      isMenuShown: false,
      menus: [],
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },
  methods: {
    ...mapActions({
      userLogin: 'auth/userLogin',
      fetchMenus: 'menus/fetchMenus',
    }),
    async validateBeforeSubmit() {
      await this.$validator.validate();
    },
    async logIn() {
      const isValid = await this.$validator.validate();
      if (isValid) {
        await this.userLogin({
          username: this.email,
          password: this.password,
        })
          .then(() => {
            this.$router.push({ name: 'PersonalWall' });
          })
          .catch((err) => {
            if (err.response && err.response.status === 401) {
              this.error = 'Email or password is incorrect';
            }
            if (err.response && err.response.status === 400) {
              this.error = 'No active account found with the given credentials';
            } else {
              this.error = 'Something went wrong';
            }
          });
      }
      return false;
    },
  },
  watch: {
    $route(to, from) {
      //  hide the collase
      if (this.isMenuShown)
        this.$root.$emit('bv::toggle::collapse', 'nav-left');
    }
  },
  async mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'nav-left') {
        this.isMenuShown = isJustShown;
      }
    });
    const menus = await this.fetchMenus();
    const processMenus = (menus, parentId = null) => {
      return menus
        .filter(menu => menu.parent_id === parentId)
        .sort((a, b) => a.position - b.position)
        .map(menu => ({
          ...menu,
          subMenus: processMenus(menus, menu.id)
        }));
    };

    const mainNav = processMenus(menus);
    this.menus = mainNav;
  }
};
</script>

<style scoped src="./Navbar.css"></style>
